// extracted by mini-css-extract-plugin
export default {"banner":"AppStore--banner--39e64e","appStoreButtons":"AppStore--appStoreButtons--56ef22"};